import { render, staticRenderFns } from "./FilterSidebarCategories.vue?vue&type=template&id=d37e724c&scoped=true"
import script from "./FilterSidebarCategories.vue?vue&type=script&lang=js"
export * from "./FilterSidebarCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d37e724c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d37e724c')) {
      api.createRecord('d37e724c', component.options)
    } else {
      api.reload('d37e724c', component.options)
    }
    module.hot.accept("./FilterSidebarCategories.vue?vue&type=template&id=d37e724c&scoped=true", function () {
      api.rerender('d37e724c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/Components/FilterSidebarCategories.vue"
export default component.exports